import { faEdit, faTimes } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';

import { PRIMARY } from 'constants/colors';

import { brightness } from 'utils/misc';

import { Box, IconButton, styled, SxProps, Tooltip } from '@mui/material';

import FontAwesomeSvgIcon from '../FontAwesomeSvgIcon';

const StyledActionCard = styled(Box)`
  display: flex;
  align-items: center;
  border: 1px solid ${PRIMARY};
  border-radius: 4px;
  background-color: ${brightness(PRIMARY, 90)};
  padding: 14px 20px;
  position: relative;
`;

const Title = styled('h3')`
  width: 330px;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  font-size: 16px;
  font-family: 'signikasemibold';
`;

type Props = {
  children?: React.ReactNode;
  sx?: SxProps;
  className?: string;
  title: string;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
};

export default function ActionCard({
  children,
  sx,
  title,
  onEditClick,
  onDeleteClick
}: Props) {
  const { t } = useTranslation('common');
  return (
    <StyledActionCard sx={sx}>
      <Title>{title}</Title>
      {children}
      <Box display="flex" justifyContent="flex-end" ml="30px" flexGrow={1}>
        {onEditClick && (
          <Tooltip title={t('edit')}>
            <IconButton onClick={onEditClick} color="primary">
              <FontAwesomeSvgIcon icon={faEdit} fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {onDeleteClick && (
          <Tooltip title={t('delete')}>
            <IconButton onClick={onDeleteClick} color="primary">
              <FontAwesomeSvgIcon icon={faTimes} fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </StyledActionCard>
  );
}
